import React, { useCallback, useMemo } from 'react';
import { Form } from 'semantic-ui-react';

export const Field = (props) => {
	const { as, name, fields, errors, data, showErrors, onChange } = props;
	const As = as ? as : Form.Input;

	const field = fields[name];
	const error = errors[name];
	const value = data[name];

	const _field = useMemo(() => {
		let copy = { ...field };
		delete copy.validate;
		delete copy.useItem;
		delete copy.base;
		return copy;
	}, [field]);

	const _props = useMemo(() => {
		let copy = { ...props };
		delete copy.showErrors;
		return copy;
	}, [props]);

	const _onChange = useCallback(
		(e, data) => {
			if (As === Form.Input) {
				if (data.value && data.value.toUpperCase) {
					data.value = data.value.toUpperCase();
				}
			}

			onChange(e, data);
		},
		[As, onChange]
	);

	return <As id={`${name}Input`} {..._field} value={value} {..._props} error={showErrors ? error : null} onChange={props.onChange ? _onChange : null} />;
};

export function useErrors(data, fields) {
	return useMemo(() => {
		let errors = {};
		let keys = Object.keys(fields);
		keys.forEach((key) => {
			var field = fields[key];
			if (field.required) {
				if (field.validate && !field.validate(data)) {
					errors[key] = true;
				} else if (!field.validate && !(data[key] !== null && data[key] !== '')) {
					errors[key] = true;
				}
			}

			if (field.minimumlength) {
                if (field.validate && !field.validate(data)) {
                    errors[key] = true;
                }else if (field.validate && data[key].length > 0 && data[key].length < field.minimumlength) {
                    errors[key] = true;
                }
			}

			if (field.maximumlength) {
                if (field.validate && !field.validate(data)) {
                    errors[key] = true;
                } else if (field.validate && data[key].length > 0 && data[key].length > field.maximumlength) {
                    errors[key] = true;
                }
			}
			
            if (field.numeric) {
                if (field.validate && !field.validate(data)) {
                    errors[key] = true;
                } else if (field.validate && data[key].length > 0 && isNaN(data[key])) {
                    errors[key] = true;
                }
            }
        });

		return errors;
	}, [data, fields]);
}

export function useIsValid(errors) {
	return useMemo(() => Object.keys(errors).length === 0, [errors]);
}

export function useForm(fields, data, errors, showErrors, onChange) {
	return useMemo(() => {
		return {
			fields,
			data,
			errors,
			showErrors,
			onChange,
		};
	}, [data, errors, fields, onChange, showErrors]);
}
